import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import InputSDataSearch from './dataSearch';
import InputDataManufacturer from './DataManufacturer';
import InputsDateFrom from './dateFrom';
import InputsDateTo from './dateTo';
// import InputsMainGroups from './maingroups';
// import InputsGroups from './groups';
// import InputsSubGroups from './subgroups';
// import InputsSubProducer from './producer';
import TransactionType from './TransactionType';
import SettlementType from './SettlementType';
import PachingType from './pachingType';

let useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
        // width: '1620px',
        minWidth:1447,
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        margin: 'auto',
        position: 'absolute',
        left: '50%',
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        border: '1px solid #E3E3E3',
        [theme.breakpoints.down("1550")]: {
            minWidth: '99%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
            padding: '20px',
            position: 'relative',
            left: '0',
            transform: "none",
        },
    },

    inputs: {
        // width: '100%',
        width: '100%',
        // maxWidth:'99%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        margin: "15px 0px",

        [theme.breakpoints.down("700")]: {
            justifyContent: 'center',
        },
    },
    inputsDate: {
        // width: '100%',
        display: 'flex',
        // justifyContent: 'space-between',
        alignItems:'center',
        width:'50%',
        [theme.breakpoints.down("700")]: {
            width:'98%',
            margin:'auto',
            flexDirection:'column',
        },
    },
    gridDate: {
        width: '99.5%',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        margin: "15px 0px",
     
        [theme.breakpoints.down("700")]: {
           marginTop:0,
        },
        
   
    },
    button: {
        backgroundColor: "#E60001",
        color: "white",
        border: 0,
        minWidth:250,
        height:44,
        marginTop:5,
        borderRadius: "8px",
        // marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("700")]: {
            width: '100%',
            margin: 'auto',
         },

    },


    gridBtn: {
        [theme.breakpoints.down("700")]: {
            width: '100%',
            margin: 'auto',
            margin: "10px 0px",
            marginTop:20,
         },
    },
    color: {
        color: '#E60001'
    }
}))

export default function Index({ state, setState, setFlagApi }) {

    let classes = useStyles();

    const handleChange = (value, key) => {
        setState({
            ...state,
            [key]: value,
        });
    };


    return (
        <div className={classes['root']}>

            <div className={classes['inputs']}>
                <TransactionType
                    state={state}
                    handleChange={handleChange} />
                <InputSDataSearch
                    state={state}
                    handleChange={handleChange} />
                <InputDataManufacturer
                    state={state}
                    handleChange={handleChange} />
                <SettlementType
                    state={state}
                    handleChange={handleChange} />
                <PachingType
                    state={state}
                    handleChange={handleChange} />
            </div>
            <div className={classes['gridDate']}>
                <div className={classes['inputsDate']}>
                    <InputsDateFrom
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />
                    <InputsDateTo
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />

                </div>
                <div className={classes['gridBtn']}>
                    <button
                        className={classes['button']}
                        onClick={() => setFlagApi(prev => !prev)}
                    >
                        فیلتر معاملات
                    </button>
                </div>
            </div>



        </div>)
}
